import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useDidUpdateEffect from '../../../common/hooks/useDidUpdateEffect'
import { Responsive } from '../../../common/Responsive'
import { debounce } from '../../../helpers/common'
import { Input } from '../../common/html/input'
import { changeFilter, selectFilter } from '../store/slice'
export const Search = () => {
  const dispatch = useDispatch()

  const text = useSelector(selectFilter('InputSearch'))

  const [inputValue, setInputValue] = useState(text)

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(changeFilter({ InputSearch: value.trim(), Page: 1 }))
    }, 700),
    [],
  )

  //useEffect
  useDidUpdateEffect(() => {
    handleChangeText(inputValue)
  }, [inputValue])

  const renderComponent = (renderHeader) => {
    return (
      <div
        className="w100"
        style={{
          paddingBottom: !renderHeader ? '12px' : 0,
          maxWidth: renderHeader ? 400 : '',
        }}
      >
        {renderHeader && <div style={{ height: 16 }}></div>}
        <Input
          containerStyle={{
            minWidth: 256,
            height: 28,
          }}
          placeHolder="library.downloadedFiles.SEARCH_FILENAME"
          type="text"
          onChange={setInputValue}
          isSearch
          value={inputValue}
        />
      </div>
    )
  }

  return (
    <>
      <Responsive renderResponsive={() => renderComponent(false)}>
        {renderComponent(true)}
      </Responsive>
    </>
  )
}
